var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5 22.5C50.5544 22.5 41.0161 26.4509 33.9835 33.4835C26.9509 40.5161 23 50.0544 23 60C23 69.9456 26.9509 79.4839 33.9835 86.5165C41.0161 93.5491 50.5544 97.5 60.5 97.5C70.4456 97.5 79.9839 93.5491 87.0165 86.5165C94.0491 79.4839 98 69.9456 98 60C98 50.0544 94.0491 40.5161 87.0165 33.4835C79.9839 26.4509 70.4456 22.5 60.5 22.5ZM8 60C8 31.005 31.505 7.5 60.5 7.5C89.495 7.5 113 31.005 113 60C113 88.995 89.495 112.5 60.5 112.5C31.505 112.5 8 88.995 8 60Z",
    fill: "#E3F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4993 22.5001C50.831 22.4783 41.5323 26.2125 34.5643 32.9151C33.1207 34.2498 31.2106 34.9644 29.2454 34.9048C27.2802 34.8452 25.4169 34.0163 24.0568 32.5966C22.6967 31.1768 21.9485 29.2797 21.9733 27.3137C21.998 25.3477 22.7938 23.4701 24.1893 22.0851C33.9489 12.7074 46.9645 7.47924 60.4993 7.50006C62.4884 7.50006 64.3961 8.29024 65.8026 9.69676C67.2091 11.1033 67.9993 13.0109 67.9993 15.0001C67.9993 16.9892 67.2091 18.8968 65.8026 20.3034C64.3961 21.7099 62.4884 22.5001 60.4993 22.5001Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verifyIcon.6b4e8858d9365b7250cbeb7c43111bff.svg";
export { ForwardRef as ReactComponent };